export default "__VITE_ASSET__0BMau1n$__"